import React from 'react';
import LandingPageNav from 'components/LandingPageNav';
import LandingPageFooter from 'components/LandingPageFooter';
import Footer from 'tailwindComponents/Footer.js';
import Head from 'next/head';
// import 'styles/landingPagestyles.css';
import ChatbotHide from 'components/ChatbotHide';
import CookieConsent from 'react-cookie-consent';
import Styles from './styles.js';
const LandingPageLayout = ({ children }) => {
  return (
    <>
      <Head>
        <script src="/static/chatbot/index.js" async></script>
      </Head>
      <CookieConsent
        id="cookie_consent"
        location="bottom"
        buttonText="Accept & Close"
        cookieName="cookie_terms_accepted"
        className="Higher"
        style={{ background: 'rgb(252, 189, 0)' }}
        expires={312}>
        <h1 className="fs-24-30 fw-400" style={{ fontFamily: 'Oswald', color: '#000000' }}>
          Cookie Policy
        </h1>
        <p className="fs-18-27 fw-400 mb-3 mb-md-4" style={{ fontFamily: 'Josefin Sans', color: '#363029' }}>
          This website uses cookies. By continuing to use this site, you accept our use of cookies.
        </p>
      </CookieConsent>
      <ChatbotHide show={true} debug={true} />
      {/* <LandingPageNotifiction
        title="Newly Launched! York University SoulRooms - 4 minutes away from campus! "
        href="/york-university-soulrooms-1"
      /> */}
      <LandingPageNav />

      <div style={{ paddingTop: '105px' }}>
        <main className="bg-white">{children}</main>
      </div>
      <Footer />
      <Styles />
    </>
  );
};

export default LandingPageLayout;
